module.exports = __webpack_public_path__ + "img/icon1.ae6a1dcd.png";